import common from "../../common";
import GelScene from "./GelScene";

export default class GelSettingsScene extends GelScene {
    constructor() {
        super();
    }

    init() {
        super.init();

        // stats
        //common.gmi.setStatsScreen && common.gmi.setStatsScreen("settings");

        common.gmi.showSettings((key, value) => {
            console.log("settings changed:", key, value);
            switch (key) {
                case "audio" : {
                    P3.audio.mute(!value);

                    // tracking
                    //common.gmi.sendStatsEvent("audio", value ? "on" : "off");
                    break;
                }
                case "subtitles" : {
                    common.subtitles.visible = value;

                    // tracking
                    //common.gmi.sendStatsEvent("subtitles", value ? "on" : "off");
                    break;
                }
                case "button_audio" : {
                    P3.audio.mute(!value, "button");

                    // tracking
                    //common.gmi.sendStatsEvent("rollover", value ? "on" : "off");
                    break;
                }
                case "motion": {
                    // tracking
                    //common.gmi.sendStatsEvent("motion", value ? "on" : "off");
                    break;
                }
            }
        }, () => {
            this.signals.next.dispatch(this);

            // tracking
            //common.gmi.sendStatsEvent("settings", "close");
        });

        // tracking
        //common.gmi.sendStatsEvent("settings", "open");
    }
}